export default {"src":"/_next/static/media/chat.1ae83eac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};